import { MembershipType } from '@acorn/util';
import { environment } from '@env';

export const MemberShipMapToIdContentful: Map<MembershipType, string> = new Map([
  [MembershipType.Bronze, environment.contentfulConfig.entryIds.bronzePlanComponent],
  [MembershipType.Silver, environment.contentfulConfig.entryIds.silverPlanComponent],
  [MembershipType.Gold, environment.contentfulConfig.entryIds.goldPlanComponent],
]);
